var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.2512C15.947 5.05422 16.1808 4.89796 16.4382 4.79136C16.6956 4.68475 16.9714 4.62988 17.25 4.62988C17.5286 4.62988 17.8044 4.68475 18.0618 4.79136C18.3192 4.89796 18.553 5.05422 18.75 5.2512C18.947 5.44819 19.1032 5.68204 19.2098 5.93941C19.3165 6.19678 19.3713 6.47263 19.3713 6.7512C19.3713 7.02978 19.3165 7.30563 19.2098 7.563C19.1032 7.82037 18.947 8.05422 18.75 8.2512L8.625 18.3762L4.5 19.5012L5.625 15.3762L15.75 5.2512Z",
    stroke: "#C7C9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.587f99dba8ca033275d4da05f528f02b.svg";
export { ForwardRef as ReactComponent };